<template>
  <z-switch :value="value" :loading="loading" size="large" @on-change="on_change" />
</template>

<script>
  import { mapActions } from 'vuex';
  import { EditableProps } from '@shared/mixins/editable-props';
  import { WorksheetService } from '@pbx/services/WorksheetService';

  export default {
    mixins: [EditableProps],

    data: () => ({
      loading: false
    }),

    methods: {
      ...mapActions('pbx/worksheets/table', ['updateItemById']),

      on_change: function(val) {
        this.loading = true;

        WorksheetService.editItem(this.id, { status: val })
          .then(res => {
            this.updateItemById(res);
            this.$emit('on-save', res);
            this.$emit('on-complete');
          })
          .finally(() => (this.loading = false));
      }
    }
  };
</script>
